export default "__VITE_ASSET__BN3Uwpdj__"